jQuery( document ).ready( function ( $ ) {
	function TWITTER( context ) {
		console.log( 'JTF TWITTER V1.0.10' )
		this.context = context
		this.init()
	}

	TWITTER.prototype.shuffle = function ( array ) {
		var currentIndex = array.length, temporaryValue, randomIndex

		// While there remain elements to shuffle...
		while ( 0 !== currentIndex ) {

			// Pick a remaining element...
			randomIndex = Math.floor( Math.random() * currentIndex )
			currentIndex -= 1

			// And swap it with the current element.
			temporaryValue = array[ currentIndex ]
			array[ currentIndex ] = array[ randomIndex ]
			array[ randomIndex ] = temporaryValue
		}

		return array
	}

	/**
	 * get suffix for a date
	 *
	 * @param date
	 * @returns {string}
	 */
	TWITTER.prototype.getSuffix = function ( date ) {
		if ( date > 3 && date < 21 ) {
			return 'th'
		}

		switch ( date % 10 ) {
			case 1:
				return "st"
			case 2:
				return "nd"
			case 3:
				return "rd"
			default:
				return "th"
		}
	}

	/**
	 * Take a string and convert any URLs in it to actual anchors
	 *
	 * @param text
	 * @returns {*}
	 */
	TWITTER.prototype.addUrl = function ( text ) {
		return text.replace( /(\b(https?|ftp|file):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z09+&@#\/%=~_|])/img, '<a href="$1">$1</a>' )
	}

	/**
	 * Get image from the media endpoint (by media ID)
	 * Choose an image randomly from the list of ID's set within the block
	 *
	 */
	TWITTER.prototype.setImage = function () {
		var self = this

		//only fire this if the twitter block has images, otherwise it complains
		if ( $( '.jtf__twitterblock--image' ).length > 0 ) {
			self.context.find( '.jtf__twitterblock--image' ).each( function () {
				const data = $( this ).attr( 'data-img' )
				let that = $( this )

				if ( data && 0 != data ) {
					let images = data.split( ',' )
					images = self.shuffle( images )

					$.ajax( {
						url: '/wp-json/wp/v2/media/' + images[ 0 ],
						dataType: "json",
						success: function ( json ) {
							// console.log( 'JSON', json )
							self.lazyLoadBgImage( that, json.media_details.sizes.medium.source_url )
						},
					} )
				} else {
					self.lazyLoadBgImage( that, 'https://covers.tandf.co.uk/covers/TANF_MR.jpg' )
				}
			} )
		}

	}

	TWITTER.prototype.lazyLoadBgImage = function ( that, image_url ) {
		// Setup lazy loading
		if ( image_url ) {
			let callback = ( entries, observer ) => {
				entries.forEach( ( entry ) => {
					if ( true == entry.isIntersecting ) {
						that.css( { 'background-image': 'url(' + image_url + ')' } )
					}
				} )
			}
			let options = {
				root: null,
				rootMargin: '150px 0px 0px 0px',
				threshold: 0,
			}
			let observer = new IntersectionObserver( callback, options )
			observer.observe( that[ 0 ] )
		}
	}

	/**
	 * Default actions happening on device actions
	 */
	TWITTER.prototype.init = function () {
		const self = this

		if ( self.context.find( '.jtf__twitterblock--theme-random' ).length > 0 ) {
			let rand = Math.floor( Math.random() * 4 ) + 1
			self.context.addClass( 'jtf__twitterblock--theme' + rand )
		}

		// console.log($( '.jtf__twitterblock--hashtags' ))

		self.context.find( '.jtf__twitterblock--hashtags' ).each( function () {
			const data = $( this ).attr( 'data-hash' )
			var that = $( this )

			if ( data ) {
				let hashtags = data.split( ',' )

				hashtags = self.shuffle( hashtags )

				//var new_hashtags = {}
				that.html( '' )

				var loop_limit = hashtags.length <= 5 ? hashtags.length : 6

				for ( let x = 0; x < loop_limit; x++ ) {
					// Create an anchor with a link back to twitter
					let tagEle = $( '<a/>', {
						class: 'jtf__twitterblock--hashtag',
						href: 'https://twitter.com/hashtag/' + hashtags[ x ].trim(),
						target: '_blank',
					} )

					// Append the hashtag as text into the new element
					tagEle.html( '#' + hashtags[ x ].trim() )
					// Add an aria-label so hashtags read correctly on screen readers
					tagEle.attr( 'aria-label', 'Open hashtag ' + hashtags[ x ].trim() + ' on Twitter' )
					// Append this back into the parent for final render
					that.append( tagEle )
				}
			}
		} )

		// If latest tweets selected, pull the tweet from twitter via the twitterendpoint in JTF
		// Also, if the tweet contains an image - use that for the centre image
		if ( self.context.find( '.jtf__twitterblock--latest' ).length > 0 ) {
			var context = self.context.find( '.jtf__twitterblock--latest' )
			var handle = context.attr( 'data-handle' )

			$.ajax( {
				url: '/wp-json/jtf/v1/twitter/single?account=' + handle,
				dataType: "json",
				success: function ( json ) {

					// console.log( json )
					const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]

					let date = new Date( json[ 0 ][ 'created_at' ] )
					let dayNumber = date.getDate()
					let month = monthNames[ date.getMonth() ]

					let handleIconContainer = $( '<a/>', {
						class: 'jtf__twitterblock--iconandhandle',
					} )

					let tweetHandle = $( '<a/>', {
						class: 'jtf__twitterblock--handle',
						href: 'https://twitter.com/' + handle,
					} )

					let tweetBird = $( '<i/>', {
						class: 'fab fa-twitter',
					} )

					handleIconContainer.html( tweetBird )
					handleIconContainer.append( tweetHandle )

					tweetHandle.html( '@' + handle )

					let tweetData = $( '<div/>', {
						class: 'jtf__twitterblock--tweet',
					} )

					let tweetDate = $( '<div/>', {
						class: 'jtf__twitterblock--tweetdate',
					} )

					tweetDate.append( month + ' ' + dayNumber + self.getSuffix( dayNumber ) )
					tweetData.html( self.addUrl( json[ 0 ][ 'full_text' ] ) )
					context.html( handleIconContainer )
					context.append( tweetData )
					context.append( tweetDate )

					let mediaItem = json?.[ 0 ]?.[ 'extended_entities' ]?.[ 'media' ]?.[ 0 ]?.[ 'media_url' ]

					if ( mediaItem ) {
						self.context.find( '.jtf__twitterblock--image' ).css( { 'background-image': 'url(' + mediaItem + ')' } )
					} else {
						self.setImage()
					}
				},
			} )
		} else {
			// If not the latest tweet AJAX, then just load a random image from our pre-selected
			self.setImage()
		}
	}

	setTimeout( function () {
		// Check TWITTER is used on this page before instantiating
		if ( $( '.wp-block-jtf-jtf-twitter' ).length > 0 ) {
			$( '.wp-block-jtf-jtf-twitter' ).each( function () {
				new TWITTER( $( this ) )
			} )
		}
	}, 1000 )
} )
